import React from 'react';
import DialogContentBase from '@material-ui/core/DialogContent';

const DialogContent = (props) => <DialogContentBase {...props} />;

export default DialogContent;
